import {
  ListItem,
  ListItemAvatar,
  ListItemText,
  Skeleton,
  Typography,
} from '@mui/material';
import { FC } from 'react';
import { isMobile } from 'react-device-detect';

const SkeletonCard: FC = () => {
  return (
    <ListItem component='div' alignItems='flex-start'>
      <ListItemAvatar sx={{ marginTop: 0, minWidth: isMobile ? 112 : 132 }}>
        <Skeleton
          animation='wave'
          variant='rectangular'
          width={isMobile ? 100 : 120}
          height={isMobile ? 100 : 120}
        />
      </ListItemAvatar>
      <ListItemText
        className='space-y-2'
        primary={<Skeleton animation='wave' />}
        primaryTypographyProps={{
          variant: 'subtitle2',
        }}
        secondary={
          <>
            <Typography variant='caption'>
              <Skeleton animation='wave' width='40%' />
            </Typography>
            <Typography variant='subtitle1'>
              <Skeleton animation='wave' width='60%' />
            </Typography>
          </>
        }
        secondaryTypographyProps={{ component: 'div' }}
      />
    </ListItem>
  );
};

export default SkeletonCard;
